import { render, staticRenderFns } from "./ListEmails.vue?vue&type=template&id=82ea7848&scoped=true&"
import script from "./ListEmails.vue?vue&type=script&lang=js&"
export * from "./ListEmails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ea7848",
  null
  
)

export default component.exports